export const API_BASE_URL = 'https://booknook-server-fqh3cgfkgqhggyg2.eastus-01.azurewebsites.net';
export const DEFAULT_PROFILE_PICTURE = '/images/default-profile.svg';
export const OPEN_SOURCE_URL = 'https://openlibrary.org';
export const OPEN_SOURCE_COVERS_URL = 'https://covers.openlibrary.org';

export const MAIN_SHELF_TYPES = [
  { id: 1, name: 'Currently Reading' },
  { id: 2, name: 'Want To Read' },
  { id: 3, name: 'Read' },
  { id: 4, name: 'Did Not Finish' }
];